// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Components Imports
import AddToClausesListBtn from "../AddToClausesListBtn";

// Actions Imports

// Services Imports

// Internal Imports
import { DocumentUtils } from "../../../utils";
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { isComponentCloneable } = DocumentUtils;

const { COMPONENT_FEATURE, TEMPLATE_SHOW_CLAUSES_FOR_COMPONENT_TYPE } =
  DOCUMENTS;

export default function ComponentClauseBtn({
  convertToClause,
  mode,
  showRemoveClausePopup,
  sectionType,
  clauseOptions,
  clauseID,
  sectionId,
}) {
  if (
    clauseOptions ||
    !isComponentCloneable(sectionType) ||
    !COMPONENT_FEATURE[mode].createClause ||
    TEMPLATE_SHOW_CLAUSES_FOR_COMPONENT_TYPE.indexOf(sectionType) < 0
  ) {
    return null;
  }

  if (clauseID === undefined || clauseID === null) {
    return <AddToClausesListBtn btnAction={convertToClause} id={sectionId} />;
  }

  return (
    <span
      className="btn-icon"
      id="remove-from-clauses-list-btn"
      onMouseDown={showRemoveClausePopup}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}>
      <Tooltip placement="left" overlay="Remove from clauses list">
        <FontAwesomeIcon icon={["far", "times-circle"]} />
      </Tooltip>
    </span>
  );
}
